module.exports = __webpack_public_path__ + "static/media/stor.59e115f4.mp3";